import useLeadCustomerQualification from "../../../UseLeadCustomerQualification";

/** A quick component wrapper to mount the legacy {@link useLeadCustomerQualification} hook. */
const AppContextUseLeadCustomerQualification: React.FC = () => {
  useLeadCustomerQualification();
  return null;
};

export default AppContextUseLeadCustomerQualification;
